import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DepartmentSelectMain from '../../../../form/fields/DepartmentSelectMain'
import { setSupplyOrdersFiltersDepartmentId } from '../../../../../store/supplyOrderSlice'

const SupplyOrdersFilterDepartment = () => {

    const departmentId = useSelector(state => state.supplyOrder.supplyOrders.filters.departmentId)
    const dispatch = useDispatch()

    const [value, setValue] = useState(departmentId ? departmentId : '')

  return (
    <DepartmentSelectMain
        // departmentTypeId={value}
        required={false}
        setValidate={e => {}}
        setValueForm={e => {
            dispatch(setSupplyOrdersFiltersDepartmentId(e))
            setValue(e)
        }}
        forciblyValue={value}
        optionDefault={{
            value: '',
            name: 'Всі'
        }}
        withoutType={true}
    />
  )
}

export default SupplyOrdersFilterDepartment